<template>
  <div class="user_label" :class="[genderClass]">
    <span class="label">{{ label }}</span>
    <span v-if="age>-1" class="age">{{ age }}岁</span>
    <span v-else  class="age">未知</span>
  </div>
</template>

<script>
export default {
  name: 'user-label',
  props: ['label', 'gender', 'age'],
  data () {
    return {
    }
  },
  computed: {
    genderClass () {
      return this.gender === 1 ? 'male' : (this.gender === 2 ? 'female' : 'unknow')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  @import "@/assets/css/mixin.scss";
  .user_label {
    width: rem(120);
    height: rem(30);
    line-height: rem(30);
    font-size: rem(22);
    color: #fff;
    text-align: center;
    border-radius: rem(26);
    background: #888;
    overflow: hidden;
    span {
      text-align: center;
      display: inline-block;
      width: rem(60);
      height: rem(30);
      &.label {
        background: #555;
      }
    }
    &.male {
      background: #82cbeb;
      .label {
        background: #5abaed;
      }
    }
    &.female {
      background: #ffa38d;
      .label {
        background: #fc7e65;
      }
    }
  }
</style>
